import { useEffect, useState } from 'react';

const useAlterSubtitleHeight = (id, { baseHeight, alterHeight }) => {
  const [topBlogHeight, setTopBlogHeight] = useState(baseHeight);

  useEffect(() => {
    const subtitles = document.querySelectorAll(`[data-testid=${id}]`);

    subtitles.forEach(item => {
      const { height } = item.getBoundingClientRect();
      if (height > 17) setTopBlogHeight(alterHeight);
    });
  }, [id, alterHeight]);

  return topBlogHeight;
};

export default useAlterSubtitleHeight;
